/* eslint-disable jsx-a11y/anchor-is-valid */
import type { LinkProps as WouterLinkProps } from 'wouter';
import clsx from 'clsx';
import React, { type FC } from 'react';
import { Link as WouterLink } from 'wouter';

type LinkProps = WouterLinkProps & {
  'data-testid'?: string;
};

export const Link: FC<LinkProps> = ({
  'data-testid': dataTestId,
  className,
  children,
  ...props
}) => (
  // We just need wouter to inject the href attribute into the A tag.
  // Using prop spreading because this is an extremely thin wrapper.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <WouterLink {...props}>
    <a data-testid={dataTestId} className={clsx(className, 'group')}>
      {children}
    </a>
  </WouterLink>
);
